import React, { Component } from 'react';
import isNumber from 'lodash/isNumber';
import UpsEulaAgreement from './UpsEulaAgreement.component';
import AddUpsAccount from './AddUpsAccount.component';
import Utils from '../../utils';
import Modal from '../../modal';
import Data from '../../data';
import CarrierUtils from '../Util';

const { Session, Communication } = Utils;
const { ModalContext, ModalButtonActionType } = Modal;
const { Carrier, InternalCapability } = Data;
class AddUpsCarrier extends Component {
	constructor(props) {
		super(props);

		const { action = '' } = this.props;
		this.state = {
			page: 1,
			deviceIdentity: '',
			isLoading: false,
			userOwnedAccount: false,
			acceptedTechnologyAgreement: false,
			communicationError: false,
			action,
		};
	}

	componentDidMount() {
		this.getDeviceIdentity();
	}

	getDeviceIdentity = () => {
		try {
			// eslint-disable-next-line no-undef
			const ioCall = ioGetBlackbox();
			this.setState({
				deviceIdentity: ioCall.blackbox,
			});
		} catch (error) {
			Communication.postLogs(error);
			this.setState({
				deviceIdentity: 'Error getting blackbox data',
			});
		}
	};

	isLoadingCarrier = isLoading => {
		this.setState(prevState => ({
			...prevState,
			isLoading,
		}));
	};

	increasePageCount = data => {
		this.setState(prevState => ({
			page: prevState.page + 1,
			coreData: data,
		}));
	};

	addCarrier = async data => {
		const { completionCallback, enterpriseLocations } = this.props;
		const { contactPhoneNumber } = Session.getBrand();
		const { accountId } = Session.getAccountInfo();
		const isSAS = isNumber(accountId) ? accountId !== 0 : false;
		let addNewCarrierResponse;
		let isAddCarrierToLocation = false;

		if (data.CustId) {
			addNewCarrierResponse = await Communication.addCarrierToLocation(data);
			isAddCarrierToLocation = true;
		} else if (enterpriseLocations) {
			isAddCarrierToLocation = true;
			addNewCarrierResponse = await Communication.addCarrierToLocations(
				CarrierUtils.createAddCarrierToLocationsRequest(enterpriseLocations, 'UPS')
			);
		} else {
			addNewCarrierResponse = await Communication.addCarrier(data);
		}

		if (Communication.isSuccessful(addNewCarrierResponse)) {
			this.isLoadingCarrier(false);

			if (!isAddCarrierToLocation) {
				let transferAuth;
				if (!isSAS) {
					const response = await Communication.getUrl({
						urlType: 'WebClientDefault',
					});
					// eslint-disable-next-line prefer-destructuring
					transferAuth = response.data.split('TransferAuthenticator=')[1];
				}
				completionCallback(true, Carrier.UPS, transferAuth);
			} else {
				completionCallback(
					true,
					Carrier.UPS,
					enterpriseLocations ? enterpriseLocations.length : null
				);
			}
		} else {
			const { showError } = this.context;

			if (addNewCarrierResponse.ErrorCode === 5637641) {
				const startIndex = addNewCarrierResponse.ErrorDescription.toString().indexOf(
						'(Reference: 2,'
					),
					endIndex = addNewCarrierResponse.ErrorDescription.toString().indexOf(
						')\n Common'
					),
					id =
						startIndex > -1 && endIndex > startIndex
							? addNewCarrierResponse.ErrorDescription.toString().substring(
									startIndex + 14,
									endIndex
							  )
							: '';
				showError({
					data: {
						title: 'Error 5637641',
						description: `We are unable able to enable UPS on your account at this time.<br/> To enable UPS label printing, please contact customer support at ${contactPhoneNumber} Monday–Friday, 6AM–6PM and provide the following number to the agent: ${id}.`,
						primaryButtonType: ModalButtonActionType.Ok,
						primaryButtonText: 'OK',
						handleType: 'custom',
					},
				});
			} else {
				showError({ response: addNewCarrierResponse });
			}

			this.isLoadingCarrier(false);
			this.setState({ communicationError: true });
		}
	};

	addSasCarrierCallback = success => {
		const { deviceIdentity } = this.state;
		const { completionCallback, custId } = this.props;

		if (success) {
			const sasData = {
				Carrier: 'UPS',
				UserOwnedAccount: false,
				AgreeToEula: true,
				DeviceIdentity: deviceIdentity,
				CustId: custId,
			};
			this.isLoadingCarrier(true);
			this.addCarrier(sasData);
		} else {
			completionCallback(false);
		}
	};

	/**
	 * Initiates Monoauth for UPS Core Account
	 * @param {Object} coreData
	 */
	initiateMonoauth = async coreData => {
		const { showError } = this.context;
		this.isLoadingCarrier(true);
		const initiateMonoauthResponse = await Communication.initiateMonoauth(coreData);

		if (Communication.isSuccessful(initiateMonoauthResponse)) {
			this.isLoadingCarrier(false);
			window.top.location.href = initiateMonoauthResponse.data;
		} else {
			this.isLoadingCarrier(false);
			showError({ response: initiateMonoauthResponse });
		}
	};

	formatTradeMark = (type, isMobile) => {
		const { userOwnedAccount } = this.state;
		if (type === 'footer') {
			return (
				<p className={isMobile ? 'footertext-mobile' : ''}>
					UPS, the UPS brandmark, UPS Ready<sup>&reg;</sup>, and the color brown are
					trademarks of United Parcel Service of America, Inc. All Rights Reserved.
				</p>
			);
		} else if (type === 'subtitle') {
			if (userOwnedAccount) {
				return (
					<p className={isMobile ? 'subtitle-mobile' : ''}>
						Next, we will configure your UPS account. You can either use your own
						account, or we can provide an account to you with with our exclusive
						discounted rates:
					</p>
				);
			}
			return (
				<p className={isMobile ? 'subtitle-mobile' : ''}>
					Use your current UPS Account, or take advantage of our UPS Preferred Merchant
					Account with discounts of up to 88% and other perks like waived fuel and
					residential surcharges for all UPS Ground<sup>&reg;</sup> shipments.
				</p>
			);
		}
	};

	handleRadioButtonChange = () => {
		this.setState(prevState => ({
			userOwnedAccount: !prevState.userOwnedAccount,
		}));
	};

	returnToAddUpsAccount = () => {
		this.setState({
			acceptedTechnologyAgreement: true,
			page: 1,
		});
	};

	render() {
		const {
			completionCallback,
			enterpriseLocations,
			editCarrierDetails,
			action = '',
			isSingleLocationSelected,
		} = this.props;

		const {
			page,
			isLoading,
			userOwnedAccount,
			acceptedTechnologyAgreement,
			communicationError,
			coreData,
		} = this.state;
		const canPrintUpsDirect = enterpriseLocations
			? enterpriseLocations[0].InternalCapabilities.includes(InternalCapability.UpsDirect)
			: Session.hasCapability(InternalCapability.UpsDirect);

		if (action === 'edit') {
			return (
				<AddUpsAccount
					carrierCallback={completionCallback}
					formatTradeMark={this.formatTradeMark}
					coreData={coreData}
					isLoading={isLoading}
					communicationError={communicationError}
					initiateMonoauth={this.initiateMonoauth}
					action={action}
					editCarrierDetails={editCarrierDetails}
				/>
			);
		} else if (canPrintUpsDirect) {
			if (page === 1) {
				return (
					<AddUpsAccount
						handleRadioButton={this.handleRadioButtonChange}
						formatTradeMark={this.formatTradeMark}
						increasePageCount={this.increasePageCount}
						userOwnedAccount={userOwnedAccount}
						carrierCallback={completionCallback}
						acceptedTechnologyAgreement={acceptedTechnologyAgreement}
						coreData={coreData}
						isLoading={isLoading}
						communicationError={communicationError}
						enterpriseLocations={enterpriseLocations}
						isSingleLocationSelected={isSingleLocationSelected}
						initiateMonoauth={this.initiateMonoauth}
					/>
				);
			} else if (page === 2) {
				if (!userOwnedAccount) {
					return (
						<UpsEulaAgreement
							type="combined"
							formatTradeMark={this.formatTradeMark}
							carrierCallback={this.addSasCarrierCallback}
							isLoading={isLoading}
							enterpriseLocations={enterpriseLocations}
						/>
					);
				}
			}
		} else {
			return (
				<UpsEulaAgreement
					type="combined"
					formatTradeMark={this.formatTradeMark}
					carrierCallback={this.addSasCarrierCallback}
					isLoading={isLoading}
					enterpriseLocations={enterpriseLocations}
				/>
			);
		}
	}
}

AddUpsCarrier.contextType = ModalContext;

export default AddUpsCarrier;
